export const EMAIL_RULES = {
  required: {
    value: true,
    message: 'Email is required.',
  },
  pattern: {
    value:
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/,
    message: 'Provided email is invalid.',
  },
};

export const PASSWORD_RULES = {
  required: {
    value: true,
    message: 'Password is required.',
  },
};

export const NEW_PASSWORD_RULES = {
  required: {
    value: true,
    message: 'New Password is required.',
  },
  pattern: {
    value: /(?=.*\d)(?=.*[a-z]).{8,}/,
    message: 'Min 8 characters with a combination of letters and numbers',
  },
};

export const FIRST_NAME_RULES = {
  required: {
    value: true,
    message: 'First name is required.',
  },
};

export const LAST_NAME_RULES = {
  required: {
    value: true,
    message: 'Last name is required.',
  },
};

export const FILE_NAME_RULES = {
  required: {
    value: true,
    message: 'File name is required.',
  },
};

export const PHONE_NUMBER_RULES = {
  pattern: {
    value: /^\+1\(\d{3}\) \d{3}-\d{4}$/,
    message: 'Provided phone number is invalid.',
  },
};

export const URL_RULES = {
  required: {
    value: true,
    message: 'URL is required.',
  },
  validate: value => {
    try {
      const url = `https://${value.replace(/^(https?:\/\/)/, '')}`;
      const validated = new URL(url);
      if (validated) {
        return true;
      }
      return 'Provided URL is invalid.';
    } catch {
      return 'Provided URL is invalid.';
    }
  },
};

export const YOUTUBE_URL_RULES = {
  required: {
    value: true,
    message: 'YouTube URL is required.',
  },
  pattern: {
    value: /^(https?:\/\/)?([a-z]+\.)?(youtube\.com|youtu\.be)\/.+$/,
    message: 'Provided YouTube URL is invalid.',
  },
  validate: value => {
    try {
      const url = `https://${value.replace(/^(https?:\/\/)/, '')}`;
      const validated = new URL(url);
      if (validated) {
        return true;
      }
      return 'Provided YouTube URL is invalid.';
    } catch {
      return 'Provided YouTube URL is invalid.';
    }
  },
};

export const DOMAIN_HINT = 'Use the base domain only, for example https://www.example.com';

const DOMAIN_WITHOUT_PATH_MESSAGE =
  'Please enter a valid domain without any sub-paths, for example https://www.example.com';

const isValidDomainHost = hostname => {
  const labels = hostname.split('.');

  return (
    labels.length > 1 &&
    labels.every(label => /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i.test(label)) &&
    labels[labels.length - 1].length >= 2
  );
};

const isIpv4Host = hostname =>
  /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname) && hostname.split('.').every(octet => Number(octet) <= 255);

export const DOMAIN_RULES = {
  required: {
    value: true,
    message: 'Please enter domain',
  },
  validate: value => {
    const trimmedValue = value?.trim();

    if (!trimmedValue) {
      return 'Please enter domain';
    }

    try {
      const url = new URL(trimmedValue.match(/^https?:\/\//i) ? trimmedValue : `https://${trimmedValue}`);
      const hasSubPath = url.pathname && url.pathname !== '/';

      if (hasSubPath || url.search || url.hash || !isValidDomainHost(url.hostname)) {
        return DOMAIN_WITHOUT_PATH_MESSAGE;
      }

      return true;
    } catch {
      return DOMAIN_WITHOUT_PATH_MESSAGE;
    }
  },
};

const CLICK_THROUGH_URL_MESSAGE = 'Provided URL is invalid, for example https://www.example.com/landing';

export const CLICK_THROUGH_URL_RULES = {
  required: {
    value: true,
    message: 'Click Through URL is required.',
  },
  validate: value => {
    const trimmedValue = value?.trim();

    if (!trimmedValue) {
      return 'Click Through URL is required.';
    }

    // "//example.com" would normalize into "https:////example.com", which the API rejects.
    if (trimmedValue.startsWith('/')) {
      return CLICK_THROUGH_URL_MESSAGE;
    }

    const isHttp = /^https?:\/\//i.test(trimmedValue);
    // The port must end the authority: "example.com:8080@evil.com" parses into credentials
    // plus a different host.
    const isHostWithPort = /^[a-z0-9][a-z0-9.-]*:\d+(?=$|[/?#])/i.test(trimmedValue);
    const hasOtherScheme = !isHttp && !isHostWithPort && /^[a-z][a-z0-9+.-]*:/i.test(trimmedValue);

    if (hasOtherScheme) {
      return CLICK_THROUGH_URL_MESSAGE;
    }

    const candidate = isHttp ? trimmedValue : `https://${trimmedValue}`;

    if (/\s/.test(candidate) || candidate.length > 2083) {
      return CLICK_THROUGH_URL_MESSAGE;
    }

    try {
      const { hostname } = new URL(candidate);

      if (!isValidDomainHost(hostname) && !isIpv4Host(hostname)) {
        return CLICK_THROUGH_URL_MESSAGE;
      }

      return true;
    } catch {
      return CLICK_THROUGH_URL_MESSAGE;
    }
  },
};
